"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharedInterleavedLine2dQuadIndexerFactory = void 0;
const shared_interleaved_point_2d_quad_indexer_1 = require("./shared-interleaved-point-2d-quad-indexer");
/**
 * @public
 * Creates a {@link ISharedInterleavedPoint2dQuadIndexer} for capless lines.
 */
class SharedInterleavedLine2dQuadIndexerFactory {
    static createOneF32(wrapper) {
        return shared_interleaved_point_2d_quad_indexer_1.SharedInterleavedPoint2dQuadIndexer.createOne(wrapper, "f32Interleaved2dLineQuadIndexer", Float32Array);
    }
    static createOneF64(wrapper) {
        return shared_interleaved_point_2d_quad_indexer_1.SharedInterleavedPoint2dQuadIndexer.createOne(wrapper, "f64Interleaved2dLineQuadIndexer", Float64Array);
    }
    static createOne(wrapper, ctor) {
        if (ctor === Float32Array) {
            return SharedInterleavedLine2dQuadIndexerFactory.createOneF32(wrapper);
        }
        else {
            return SharedInterleavedLine2dQuadIndexerFactory.createOneF64(wrapper);
        }
    }
}
exports.SharedInterleavedLine2dQuadIndexerFactory = SharedInterleavedLine2dQuadIndexerFactory;
//# sourceMappingURL=shared-interleaved-line-2d-quad-indexer-factory.js.map